import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=ad800692"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=ad800692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports